import axios from 'axios'

export default {
    INTEREST ({commit}) {
        return axios.get('interests').then((response) => {
            const { data: { data } } = response
            if (data.length && !data.error) {
                commit('setInterest', { interests: data })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETALLINTERESTS ({ commit }, corporationId) {
        return axios.get(`/interests/${corporationId}`).then((response) => {
            const { data: { data } } = response
            commit('interestList', {interests: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETALLEMAILDAYS ({ commit }, userId) {
        return axios.get(`user/email-delivery-days/users/${userId}`).then((response) => {
            return response.data.data.payload
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETUSERINTERESTS ({ commit }, userId) {
        return axios.get(`/interests/getByUserId/${userId}`).then((response) => {
            console.log('response', response)
            const { data: { data } } = response
            commit('SetUserInterests', {userInterests: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    UPDATEINTERESTS ({ commit }, { loggedUser }) {
        return axios.put('/profile/updateUserInterests', loggedUser).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
            } else {
                commit('setError', { error: {show: true, message: data.message} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/interest/actions.js